import { charaSize } from "./constants";
import { SoundManager } from "./managers/soundManager";
import { setupTitle } from "./scenes/title";
import { setupStage, scaffold, heart, cat } from "./scenes/stage";
import { createRect } from "./managers/collisionManager";

type GameState = "title" | "stage";

const HEIGHT = 480 * 3;

export class Game {
  private _dispose: () => void = () => {};
  private soundManager = new SoundManager();

  constructor(
    private parent: PIXI.Container,
    private ticker: PIXI.Ticker,
    private state: GameState = "title",
  ) {}

  render() {
    this._dispose();
    if (this.state === "title") {
      this._dispose = setupTitle({
        parent: this.parent,
        ticker: this.ticker,
        soundManager: this.soundManager,
        goNext: () => {
          this.state = "stage";
          this.render();
        },
      });
    } else {
      this._dispose = setupStage({
        parent: this.parent,
        ticker: this.ticker,
        soundManager: this.soundManager,
        width: charaSize * 32,
        height: HEIGHT,
        timeLimit: 200 * 1000,
        playerInitialPos: {
          x: charaSize / 2,
          y: HEIGHT - charaSize / 2,
        },
        items: [
          scaffold({
            x: charaSize * 2,
            y: HEIGHT - charaSize * 3,
            width: charaSize * 3,
          }),
          scaffold({
            x: 0,
            y: HEIGHT - charaSize * 8,
            width: charaSize,
          }),
          heart({
            x: charaSize / 2,
            y: HEIGHT - charaSize * 8.5,
          }),
          scaffold({
            x: charaSize * 7,
            y: HEIGHT - charaSize * 6,
            width: charaSize * 8,
          }),
          cat({
            startX: charaSize * 8,
            endX: charaSize * 14,
            y: HEIGHT - charaSize * 6.5,
            intervalMs: 3000,
          }),
          // cat
          scaffold({
            x: charaSize * 17,
            y: HEIGHT - charaSize * 7,
            width: charaSize * 3,
          }),
          scaffold({
            x: charaSize * 22,
            y: HEIGHT - charaSize * 8,
            width: charaSize * 2,
          }),
          scaffold({
            x: charaSize * 27,
            y: HEIGHT - charaSize * 8,
            width: charaSize * 3,
          }),
          scaffold({
            x: charaSize * 31,
            y: HEIGHT - charaSize * 6,
            width: charaSize,
          }),
          heart({
            x: charaSize * 31.5,
            y: HEIGHT - charaSize * 6.5,
          }),
          scaffold({
            x: charaSize * 31,
            y: HEIGHT - charaSize * 13,
            width: charaSize,
          }),
          scaffold({
            x: charaSize * 20,
            y: HEIGHT - charaSize * 18,
            width: charaSize * 10,
          }),
          cat({
            startX: charaSize * 21,
            endX: charaSize * 29,
            y: HEIGHT - charaSize * 18.5,
            intervalMs: 4000,
          }),
          // cat
          scaffold({
            x: charaSize * 14,
            y: HEIGHT - charaSize * 15,
            width: charaSize * 6,
          }),
          scaffold({
            x: charaSize * 21.5,
            y: HEIGHT - charaSize * 15,
            width: charaSize * 2,
          }),
          heart({
            x: charaSize * 22.5,
            y: HEIGHT - charaSize * 15.5,
          }),
          scaffold({
            x: 0,
            y: HEIGHT - charaSize * 17,
            width: charaSize * 8,
          }),
        ],
        loliPosition: {
          x: charaSize * 3,
          y: HEIGHT - charaSize * 18,
        },
        goalRect: createRect(
          "goal",
          0,
          HEIGHT - charaSize * 17 - 1,
          charaSize * 5,
          1,
        ),
        retry: () => {
          this.render();
        },
        backToTitle: () => {
          this.state = "title";
          this.render();
        },
      });
    }
  }
}
